import React, { useState } from 'react';

interface IncomeInputProps {
  pensionMonthlyBenefit: number;
  onSocialSecurityChange: (socialSecurity: number) => void;
  onPensionChange: (pension: number) => void;
}

const IncomeInput: React.FC<IncomeInputProps> = ({ onSocialSecurityChange, onPensionChange }) => {
    const [socialSecurity, setSocialSecurity] = useState<number>(0);
    const [pension, setPension] = useState<number>(0);
    const handleSocialSecurityChange = (value: string) => {
        const numValue = parseFloat(value) || 0;
        setSocialSecurity(numValue);
        onSocialSecurityChange(numValue);
    };
    const handlePensionChange = (value: string) => {
        const numValue = parseFloat(value) || 0;
        setPension(numValue);
        onPensionChange(numValue);
    };
    return (
    <div className="income-input">
      <h2>Income</h2>
      <div className="input-group">
        <label htmlFor="socialSecurity">Social Security Monthly Benefit ($):</label>
        <input
          id="socialSecurity"
          type="number"
          value={socialSecurity}
          onChange={(e) => handleSocialSecurityChange(e.target.value)}
        />
        <small>Social Security payments will be increased by estimated annual COLAs.</small>
      </div>
      <div className="input-group">
        <label htmlFor="socialSecurity">Pension Monthly Benefit ($):</label> <em><small>Not implemented yet</small></em>
        <input 
          disabled
          id="pension"
          type="number"
          value={pension}
          onChange={(e) => handlePensionChange(e.target.value)}
        />
      </div>
    </div>
  );
};

export default IncomeInput;